import React, { useContext, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { supabase } from "../services/supabaseClient";
import { CoachContext } from "../CoachProvider";
import { PageLoader } from "./page-loader";

// Guard basado en Supabase Auth:
//  - sin sesión           -> /login
//  - sesión, coach cargando -> loader
//  - sesión sin coach activo -> signOut + /login?error=not_authorized
//  - sesión + coach activo  -> render del componente
export const AuthenticationGuard = ({ component: Component }) => {
  const [session, setSession] = useState(undefined); // undefined = cargando, null = sin sesión
  const { coach, isLoading: coachLoading } = useContext(CoachContext);

  useEffect(() => {
    let mounted = true;
    // onAuthStateChange emite INITIAL_SESSION *después* de que supabase-js procese
    // el token del magic link en la URL. Es la señal fiable del estado inicial:
    // usarla (en lugar de getSession, que puede resolver null antes de procesar
    // la URL) evita el rebote a /login en el primer render tras el redirect.
    const { data: sub } = supabase.auth.onAuthStateChange((_event, s) => {
      if (mounted) setSession(s ?? null);
    });
    return () => {
      mounted = false;
      sub?.subscription?.unsubscribe();
    };
  }, []);

  const notAuthorized = !!session && !coachLoading && (!coach || coach.active === false);

  useEffect(() => {
    if (notAuthorized) supabase.auth.signOut();
  }, [notAuthorized]);

  if (session === undefined || (session && coachLoading)) {
    return (
      <div className="page-layout">
        <PageLoader />
      </div>
    );
  }
  if (!session) return <Navigate to="/login" replace />;
  if (notAuthorized) return <Navigate to="/login?error=not_authorized" replace />;

  return <Component />;
};
